import React from 'react';
import loadable from '@loadable/component';
import Loading from './Loading';

const WPLoadable = (opts) =>
  loadable(opts.loader, {
    fallback: <Loading />,
  });

export default WPLoadable;
